import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { FloatButton } from "antd";
import { Footer } from "./Components";
import { Home, NoPage} from "./Pages";
import Checker from "./Pages/Checker";


function App() {
  return (
    <div className="App scroll-smooth bg-black">

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/checker" element={< Checker/>} />
          <Route path="/*" element={<NoPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>

      <FloatButton.BackTop />
    </div>
  );
}

export default App;
